export default function Cookie() {
  const cookie = document.cookie;
  const params = cookie.split(';').reduce((prev, row) => {
    const [key, value] = row.split('=');
    return { ...prev, [key.trim()]: value };
  }, {});

  return params;
}
